import { render, staticRenderFns } from "./CompetitorsFilters.vue?vue&type=template&id=7be39e88&scoped=true"
import script from "./CompetitorsFilters.vue?vue&type=script&lang=js"
export * from "./CompetitorsFilters.vue?vue&type=script&lang=js"
import style0 from "./CompetitorsFilters.vue?vue&type=style&index=0&id=7be39e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be39e88",
  null
  
)

export default component.exports